// removed by extract-text-webpack-plugin
module.exports = {"PeopleCounter":"People__PeopleCounter__2cC5V","CreditCardLoaderContainer":"People__CreditCardLoaderContainer__35eed","MaxPeopleText":"People__MaxPeopleText__c0-9w","PeopleVisual":"People__PeopleVisual__2HYhR","PeopleNumber":"People__PeopleNumber__cYCgt","Title":"People__Title__QPsG6","CreditCardImage":"People__CreditCardImage__3_wZb","ModalContentContainer":"People__ModalContentContainer__2S5Sz","ModalTitle":"People__ModalTitle__9BmSn","ModalText":"People__ModalText__2g7Fa","PhoneLink":"People__PhoneLink__3aTBw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/People/People.css
// module id = 166
// module chunks = 0